import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum LuckySlotZIndex {
  loadingPage = 9999,
  smallWinAmis = 25,
  bigWinAmis = 30,
  bonusWinAmis = 1000,
  guidePage = 5000,
  taskPop = 5000,
  taskBox = 20,
  beatArea = 18,
  mainBox = 10,
  light = 15,
  header = 24,
}

export enum StatusEnum {
  未完成 = 0,
  完成未领取 = 1,
  完成已领取 = 2,
}
export enum freePlayActionTypeEnum {
  非目标用户 = 0,
  命中奖励 = 1,
  免费任务有效 = 2,
}
export enum freePlayGuideStepEnum {
  freespin引导 = 1,
  freespin引导状态扭转中 = '1-1',
  freespin中 = 2,
  自动调整线数 = 3,
  spin = 4,
  none = 0,
}

export enum subPageName {
  排行榜 = 'RankModal',
  规则页 = 'RuleModal',
  记录页 = 'RecordModal',
}

export enum BulletMtypeEnum {
  common = 1,
  freespin = 2,
  bonus = 3,
  jackpot = 4,
}

export enum ElementTypeEnum {
  common = 1,
  wild = 2,
  scatter = 3,
  bonus = 4,
  jackpot = 5,
}
export enum LineWinTypeEnum {
  big = 'big',
  mega = 'mega',
  ecip = 'ecip',
  jackpot = 'jackpot',
  bonusret = 'bonusret',
}
export enum BetResultStatusEnum { // 下注结果
  notEnough = 2,
  changeLineOrBet = 3,
  success = 1,
}

export enum LuckySlotSoundEnum {
  bigWin = `${HostMaps.prod.img01}/download/file?obj=hbfile/48/58/cda3-65ac-11ef-ad98-00163e0ecc6a` as any,
  bonusJackpotWin = `${HostMaps.prod.img01}/download/file?obj=hbfile/8f/3f/ef63-65ac-11ef-8f77-00163e0e06a5` as any,
  freeSpin = `${HostMaps.prod.img01}/download/file?obj=hbfile/b8/00/51dc-65ac-11ef-8f77-00163e0e06a5` as any,
  goGame = `${HostMaps.prod.img01}/download/file?obj=hbfile/49/b8/de64-65b0-11ef-8f77-00163e0e06a5` as any,
  line = `${HostMaps.prod.img01}/download/file?obj=hbfile/a4/3b/6c93-65b0-11ef-8f77-00163e0e06a5` as any,
  lineStop = `${HostMaps.prod.img01}/download/file?obj=hbfile/b3/c4/ae7e-65b0-11ef-ad98-00163e0ecc6a` as any,
  megaWin = `${HostMaps.prod.img01}/download/file?obj=hbfile/c6/f7/9c88-65b0-11ef-ad98-00163e0ecc6a` as any,
  spin = `${HostMaps.prod.img01}/download/file?obj=hbfile/d9/04/c40a-65b0-11ef-8f77-00163e0e06a5` as any,
  stop = `${HostMaps.prod.img01}download/file?obj=hbfile/eb/8b/9eae-65b0-11ef-ad98-00163e0ecc6a` as any,
  superWin = `${HostMaps.prod.img01}/download/file?obj=hbfile/fc/33/e5bb-65b0-11ef-8f77-00163e0e06a5` as any,
  zhuixian = `${HostMaps.prod.img01}/download/file?obj=hbfile/0a/e1/b0d2-65b1-11ef-8f77-00163e0e06a5` as any,
  zhuixianfast = `${HostMaps.prod.img01}/download/file?obj=hbfile/17/c9/b684-65b1-11ef-8f77-00163e0e06a5` as any,
}
export enum LuckySlotSoundTypeEnum {
  '停止' = 'stop',
  '进小游戏' = 'goGame',
  '连线' = 'line',
  '每列停' = 'lineStop',
  '抽奖' = 'spin',
  '大奖' = 'bigWin',
  '中奖' = 'megaWin',
  '超级大奖' = 'superWin',
  '免费抽' = 'freeSpin',
  '追线' = 'zhuixian',
  '追线快速' = 'zhuixianfast',
  'bonusJackpotWin' = 'bonusJackpotWin',
}

export enum BonusLogEnum {
  宝箱动画展示页 = 1,
  选择宝箱页 = 2,
  宝箱结果页 = 3,
  主动点击宝箱动画展示页的按钮 = 1,
  主动点击选择宝箱页中的宝箱 = 2,
}

export enum SlotKingStateEnum {
  // 2:冠军公布;0:蓄力中;1:抢夺中
  energy = 0,
  snatch = 1,
  resultShow = 2,
}
